import {
  BookingDetailResponse,
  UpdateDetailApiPayload,
} from 'types/BookingDetails';
import { BranchResponse } from 'types/branch';
import bookingAxiosApi from './bookingAxiosApi';
import { VehicleResponse } from 'types/products';
import { CreateBookingPayload } from 'types/BookingCreate';
import { IBookingUI } from 'types/BookingDetailsV1';

export const getVehicles = async (id: string): Promise<VehicleResponse> => {
  const { data } = await bookingAxiosApi.get<VehicleResponse>(
    `/booking/listing?id=${id}`
  );
  return data;
};
export const getBookingDetail = async (
  id: string,
  vId: string
): Promise<BookingDetailResponse> => {
  const { data } = await bookingAxiosApi.get<BookingDetailResponse>(
    `/booking/detail/?id=${id}&vid=${vId}`
  );
  return data;
};

export const updateBookingAddons = async (
  payload: UpdateDetailApiPayload
): Promise<string> => {
  const { data } = await bookingAxiosApi.put('/booking/detail', payload);
  return data;
};

export const getCheckoutBookingDetails = async (
  detailsId: string
): Promise<BookingDetailResponse> => {
  const { data } = await bookingAxiosApi.get(
    `/booking/checkout?id=${detailsId}`
  );
  return data;
};

export async function createBooking(payload: CreateBookingPayload) {
  const { data } = await bookingAxiosApi.put('/booking/create', payload);
  return data;
}

export const getBookingById = async (
  bookingId: string
): Promise<IBookingUI> => {
  if (bookingId) {
    const { data } = await bookingAxiosApi.get(
      `/booking/create?id=${bookingId}`
    );
    return data.data;
  } else {
    throw new Error('booking details not found');
  }
};
